import { z } from "zod";

/**
 * Zod schema for push notification data payload.
 *
 * Fields from the native bridge typically arrive as strings, but APNs custom data
 * supports any JSON type, so numeric values (e.g., ttlSeconds: 60) can arrive from
 * the native bridge. Using z.coerce.string() converts non-strings gracefully, and
 * .catch(undefined) ensures one mistyped field doesn't cause total data loss.
 *
 * z.coerce.string() would convert null to the string "null" via String(null),
 * so we preprocess null → undefined before coercion to treat null as absent.
 */
const nullSafeString = z
  .preprocess((value) => (value === null ? undefined : value), z.coerce.string().optional())
  .catch(undefined);

export const notificationDataSchema = z.object({
  type: nullSafeString,
  link: nullSafeString,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  channel_url: nullSafeString,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  custom_type: nullSafeString,
  messageId: nullSafeString,
  method: nullSafeString,
  ttlSeconds: nullSafeString,
  createdTimeUTC: nullSafeString,
});

export type NotificationData = z.infer<typeof notificationDataSchema>;

/**
 * sessionStorage key for storing an unconsumed notification link
 * that arrived before the user was authenticated.
 */
export const UNCONSUMED_NOTIFICATION_LINK_KEY = "unconsumedNotificationLink";
